import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CRM_API_CONTACTUS_API_URL, CRM_API_TOKEN } from '../../shared/constants';

import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar'
import { timeout } from 'rxjs/operators';

@Component({
  selector: 'app-contactus-form',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule
],
  templateUrl: './contactus-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contactus-form.component.scss'
})
export class ContactusFormComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
  ) { }

  formGroup: FormGroup = new FormGroup({
    name: new FormControl('', [
      Validators.required,
      Validators.minLength(4),
      Validators.maxLength(200),
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.minLength(4),
      Validators.maxLength(200),
      Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')
    ]),
    subject: new FormControl('', [
      Validators.required,
      Validators.minLength(4),
      Validators.maxLength(200),
      Validators.pattern('^[a-zA-Z0-9_\\-\\s]*$')
    ]),
    message: new FormControl('', [
      Validators.required,
      Validators.minLength(4),
      Validators.maxLength(2000),
      Validators.pattern('^[a-zA-Z0-9_\\-\\s]*$')
    ]),
  })

  successMessage: string = ''
  token: string = CRM_API_TOKEN

  ngOnInit(): void {
    this.initializeForm()
  }

  initializeForm() {
    this.route.queryParams.subscribe(params => {
      const isTest = params['isTest']
      if (isTest == 'true') {
        this.formGroup.setValue({
          email: "navkam9@gmail.com",
          message: "Here is a test message",
          name: "Robert Williams",
          subject: "Need more information about your services",
          navigationOption: this.formGroup.get('navigationOption')?.value
        });
      }
    })
  }

  onSubmit() {
    if (this.formGroup.invalid) {
      const invalidFields = Object.keys(this.formGroup.controls).filter(field => {
        return this.formGroup.get(field)?.invalid;
      });

      let errorMessage = "Validation error : ";
      invalidFields.forEach(field => {
        const controlErrors = this.formGroup.get(field)?.errors;
        if (controlErrors) {
          Object.keys(controlErrors).forEach(keyError => {
            errorMessage += `${field} - ${keyError}; `;
          });
        }
      });

      this.snackBar.open(errorMessage, 'Close', {
        duration: 3000,
        panelClass: ['error-snackbar']
      });
      return;
    }
 
    this.successMessage = 'Thank you for contacting us! We will get back to you soon.';

    const headers = new HttpHeaders({
      'Authorization': `Basic ${this.token}`,
      'Content-Type': 'application/json',
    })

    this.http.post(CRM_API_CONTACTUS_API_URL, this.formGroup.value, { headers, observe: 'response' }).pipe(
      timeout(60000)
    ).subscribe({
      next: data => { 
        var jsonResponse = JSON.parse(JSON.stringify(data))

        this.snackBar.open(this.successMessage, 'Close', {
          duration: 5000,
          panelClass: ['error-snackbar']
        })
        this.formGroup.reset()
      },
      error: error => {
        var jsonResponse = JSON.parse(JSON.stringify(error)).error

        if (jsonResponse.status == 400) {
          if (jsonResponse.shortCode == "validation-error") {
            //this.validationResult = jsonResponse.message
            this.snackBar.open(jsonResponse.message.message, 'Close', {
              duration: 5000,
              panelClass: ['error-snackbar']
            })
          } else {
            this.snackBar.open(jsonResponse.message.message, 'Close', {
              duration: 5000,
              panelClass: ['error-snackbar']
            })
          }
        } else if (error.status == 500) {
          this.snackBar.open(error, 'Close', {
            duration: 5000,
            panelClass: ['error-snackbar']
          })
        } else {
          this.snackBar.open(jsonResponse.message, 'Close', {
            duration: 5000,
            panelClass: ['error-snackbar']
          })
        }

      },
      complete: () => {
      }
    })
  }
}
